import React, {useEffect, useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import Layout from '../components/Layout';
import {api} from '../../api';

export default function AddTimesheet() {
  const navigate = useNavigate();
  const [employees, setEmployees] = useState([]);
  const [form, setForm] = useState({employeeId: '', startDate: '', endDate: '', status: 'DRAFT'});

  useEffect(() => {
    api('/hcm/employees').then(r => r.ok ? r.json() : []).then(setEmployees);
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    api('/timesheets/timesheets', {method: 'POST', body: JSON.stringify(form)})
      .then(r => r.json()).then(ts => navigate(`/timesheets/${ts.id}`, {state: {saved: true}}));
  };

  const set = (field) => (e) => setForm(f => ({...f, [field]: e.target.value}));

  return (
    <Layout>
      <Link to="/timesheets" className="text-teal-600 hover:text-teal-800 mb-4 inline-block">&larr; Back</Link>
      <h2 className="text-2xl font-bold text-gray-900 mb-6">New Timesheet</h2>
      <form onSubmit={handleSubmit} className="bg-white rounded-lg shadow p-6 max-w-2xl space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-1">Employee</label>
          <select required value={form.employeeId} onChange={set('employeeId')}
            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500">
            <option value="">Select employee...</option>
            {employees.map(e => <option key={e.id} value={e.id}>{e.firstName} {e.lastName}</option>)}
          </select>
        </div>
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Start Date</label>
            <input type="date" required value={form.startDate} onChange={set('startDate')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">End Date</label>
            <input type="date" required value={form.endDate} onChange={set('endDate')}
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-teal-500" />
          </div>
        </div>
        <div className="flex gap-3">
          <button type="submit" className="px-6 py-2 bg-teal-600 text-white rounded-lg hover:bg-teal-700">Create</button>
          <Link to="/timesheets" className="px-6 py-2 border border-gray-300 rounded-lg hover:bg-gray-50">Cancel</Link>
        </div>
      </form>
    </Layout>
  );
}
